import { useMutation } from '@tanstack/react-query';

import { updateApprovalCaseApi } from '../api';

export default function useUpdateApprovalCaseMutation(options?: any) {
  return useMutation(updateApprovalCaseApi, options);
}
